module.exports = __webpack_public_path__ + "static/media/checklist3.f947c14c.svg";